export const pageContent = {
  slideX: {
    slideContent:
      "The text content for the given slide, usually a paragraph or two. In the intro slide, this content represents the DEK. If the text includes more than one paragraph, just write {newParagraph} in between to split it up. Do not separate the paragraphs with line breaks.",
    photoFileName:
      "The file name of the photo that goes with the content above. The name needs to match exactly and include the suffix at the end (for example: “060223_fort_greene_interrupters_crop_1.jpg”) If left blank, the content will show up on a blank screen. (OPTIONAL)",
    photoPosition:
      "For engineers to fill out. This specifies what part of the photo should be centered on mobile. (OPTIONAL)",
  },
  slide0: {
    slideContent:
      "Making My Force and My Face Known: Queer wrestlers enter the ring in Red Hook.",
    photoFileName: "061123_lgbtq_wrestling_17.jpg",
  },
  slide1: {
    slideContent:
      "“I get comments about how empowering it is to see someone like me, who is not a natural-born, cisgendered woman,” said wrestler Coco Mousse. {newParagraph} “And I don’t have a small stature. I don’t have a small frame. I don’t embody what Western culture considers a woman, but being out there, making my force and my face known, helps me to really exude this inner me.”",
    photoFileName: "061123_lgbtq_wrestling_2.jpg",
  },
  slide2: {
    slideContent:
      "A Matter of Pride has been promoting queer wrestling events throughout the five boroughs since 2016. {newParagraph} The group holds several bouts a year throughout the city, attracting a loyal fan base, including one on June 11 at Strong Rope Brewery in Red Hook.",
    photoFileName: "061123_lgbtq_wrestling_12.jpg",
  },
  slide3: {
    slideContent:
      "Drag performer Novaczar jokes around with wrestlers before their bouts.",
    photoFileName: "061123_lgbtq_wrestling_20.jpg",
    photoPosition: "70% center",
  },
  slide4: {
    slideContent:
      "A Pride unicorn works the crowd before the matches began, giving brewery-goers, many of whom were there with families, a preview of what was to come.",
    photoFileName: "061123_lgbtq_wrestling_5.jpg",
    photoPosition: "60% center",
  },
  slide5: {
    slideContent:
      "“I’m a Black trans woman myself and I’ve also found a lot of empowerment through women’s wrestling,” said Mimi Shelton, who came with friends. {newParagraph} “Particularly now with the evolution of women's wrestling on television. And now that there's like the opportunity in the indie circuit to have like queer-specific wrestling circuits.”",
    photoFileName: "061123_lgbtq_wrestling_4.jpg",
  },
  slide6: {
    slideContent:
      "Sebastian LeShawn, left, takes the upper hand, or foot, against Paris Sahara while the crowd becomes increasingly vocal.",
    photoFileName: "061123_lgbtq_wrestling_1.jpg",
  },
  slide7: {
    slideContent:
      "“I don’t know what happened when I was like six, seven years old, but [WWE star] Trish Stratus came out and started getting in Christy Hemme’s face and now all of a sudden I’m invested and I’m like, ‘I have to see where this goes,’” said Jadis Quinn, who flew through the air while delivering a kick to Gia Scott. {newParagraph} “Women inspired me. It was women all around.”",
    photoFileName: "061123_lgbtq_wrestling_13_crop.jpg",
  },
  slide8: {
    slideContent:
      "DiDi Opulence performs a drag show between the wrestling matches, before delivering an emotional plea to support LGBTQ rights.",
    photoFileName: "061123_lgbtq_wrestling_9.jpg",
    photoPosition: "top center",
  },
  slide9: {
    slideContent:
      "“It is a tough time for the community right now,” DiDi Opulence said.",
    photoFileName:
      "https://s3.amazonaws.com/static.thecity.nyc/video/drag-story-hour-queens-library.mp4",
  },
  slide10: {
    slideContent:
      "There was a mix of families, Sunday-afternoon drinkers and indie wrestling fans in the crowd.",
    photoFileName: "061123_lgbtq_wrestling_15.jpg",
  },
  slide11: {
    slideContent:
      "Though the event was held in a corner of Brooklyn far from the subway, there were reminders of how the area has become a cruise ship destination.",
    photoFileName: "061123_lbgtq_wrestling_7_crop.jpg",
  },
  slide12: {
    slideContent:
      "“Being in the South in wrestling has been challenging, because you come across a lot of people that run promotions that are very behind the times, and they still want to kind of live in that mentality,” said Beauxx Bombshell, who grew up below the Mason-Dixon line. {newParagraph} “And like now I've been able to change the minds of promoters in the South — so it's been pretty wild. Like almost every promotion I worked at, I started off as heel and I ended up as face, baby face, the good guy.”",
    photoFileName: "061123_lgbtq_wrestling_18.jpg",
    photoPosition: "15% top",
  },
  slide13: {
    slideContent:
      "The Boy Diva takes over in the title bout against Roger “$#!@ Talker” Mendez. Mendez said he was just in it “for the money” and not to support any political cause.",
    photoFileName: "061123_lgbtq_wrestling_10.jpg",
  },
  slide14: {
    slideContent:
      "“Yes, we’re camp, we’re silly, we’re sexy and we’re characters, but also we’re really going out there and beating the shit out of each other,” said The Boy Diva. {newParagraph} “We’re not Jello wrestling, we’re not play-fighting, we’re not pretend-smacking, we’re really trained athletes who are competitors.”",
    photoFileName: "061123_lgbtq_wrestling_11.jpg",
    photoPosition: "bottom center",
  },
};
